import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from 'axios';
import { InputText } from 'primereact/inputtext';
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { Paginator } from 'primereact/paginator';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import classNames from 'classnames';
import '../../assets/layout/styling.css';
import exportData from "../../services/exportToExcelService";
import AccessControl from "../AccessControl";
import NoAccess from "../NoAccess";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";
import { MultiSelect } from 'primereact/multiselect';

const CompanyWiseAttendees = () => {
    const [CompanyWiseAttendeesData, setCompanyWiseAttendeesData] = useState([]);
    const [companyNameFilter, setCompanyNameFilter] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [companyList, setCompanyList] = useState([]);
    const [filterDialog, setFilterDialog] = useState(false);

    const toast = useRef(null);
    const dt = useRef(null);
    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: 1,
        CompanyFilter: null
    }); // For Sorting And Pagination Purpose

    useEffect(() => {
        getCompanyWiseAttendees();
        getFilterListsData();
    }, []);

    const getCompanyWiseAttendees = (isExportExcel = false, event) => {
        //Company filter extraction
        const currentFilter = (event && event.CompanyFilter !== undefined)
            ? event.CompanyFilter
            : lazyState.current.CompanyFilter;

        var listCompanyFilterString = null;
        if (currentFilter != null && currentFilter != undefined && currentFilter != '') {
            if (Array.isArray(currentFilter) && currentFilter.length > 0) {
                listCompanyFilterString = currentFilter
                    .map(item => (typeof item === 'object' && item !== null ? item.name : item))
                    .filter(Boolean)
                    .join(',');
            } else if (typeof currentFilter === 'object' && currentFilter.name) {
                listCompanyFilterString = currentFilter.name;
            } else if (typeof currentFilter === 'string') {
                listCompanyFilterString = currentFilter;
            }
        }
        if (listCompanyFilterString === '') listCompanyFilterString = null;

        setIsLoading(true);
        setCompanyWiseAttendeesData([]);
        if (!isExportExcel) setCompanyWiseAttendeesData([]);

        axios.post('/api/Report/GetAllCompanyAttendees', {
            paginationRequired: !isExportExcel,
            SortDirection: lazyState.current.sortOrder,
            PageSize: lazyState.current.rows,
            CurrentPageNumber: event && event.rows ? ((event.first / event.rows) + 1) : lazyState.current.page,
            SortField: event && event.sortField ? event.sortField : "Name",
            CompanyName: listCompanyFilterString ? listCompanyFilterString : null,
            CompanyFilter: listCompanyFilterString ? listCompanyFilterString : null
        }).then(Response => {
            setTotalRecords(Response.data.totalRecords);
            setCompanyWiseAttendeesData(Response.data.data);
            let tempData = [];
            for (let dataObj of Response.data.data) {
                let excelcolumnData = {
                    Company: dataObj.companyName,
                    Approved: dataObj.approvedstatus,
                    Rejected: dataObj.rejectedstatus,
                    Cancelled: dataObj.cancelledstatus,
                    Present: dataObj.presetattendees,
                };
                tempData.push(excelcolumnData);
            };
            if (isExportExcel) {
                exportData(tempData, 'CompanyWiseAttendee');
                setIsLoading(false);
                return false;
            };
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
        });
    };

    const getFilterListsData = () => {
        setIsLoading(true);
        axios
            .get("/api/Participant/GetAllFilterListData")
            .then((Response) => {
                const separatedLists = Response.data.reduce((acc, item) => {
                    // Create a new array for each type if it doesn't exist
                    if (!acc[item.type]) {
                        acc[item.type] = [];
                    }
                    // Push the formatted item to the respective array
                    acc[item.type].push({ name: item.name, code: item.name });
                    return acc;
                }, {});

                // Sort each list by 'name'
                Object.keys(separatedLists).forEach(type => {
                    separatedLists[type].sort((a, b) => a.name.localeCompare(b.name));
                });
                setCompanyList(separatedLists.Company || []);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: "Oops! Something Went Wrong!", life: 3000 });
            });
    };

    // For Sorting 
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getCompanyWiseAttendees(false, lazyState.current);
    };

    //pagination
    const onBasicPageChange = (event) => {
        setIsLoading(true);
        lazyState.current.sortField = lazyState.current.sortField;
        lazyState.current.sortOrder = lazyState.current.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getCompanyWiseAttendees(false, lazyState.current);
        setIsLoading(false);
    };

    const removeFilter = () => {
        lazyState.current.CompanyFilter = null;
        setCompanyNameFilter(null);
        getCompanyWiseAttendees(false, { CompanyFilter: null });
    };

    const isFilterActive = !(
        lazyState.current.CompanyFilter == null ||
        (Array.isArray(lazyState.current.CompanyFilter) && lazyState.current.CompanyFilter.length === 0) ||
        lazyState.current.CompanyFilter === ''
    );

    const SearchFilter = () => {
        getCompanyWiseAttendees(false, lazyState.current);
        setFilterDialog(false);
    };

    const CompanyFilterTemplate = () => {
        return (
            <MultiSelect
                value={companyNameFilter || lazyState.current.CompanyFilter}
                options={companyList}
                itemTemplate={CompanyFilterItemTemplate}
                optionLabel="name"
                onChange={(e) => CompanyFilterClick(e)}
                placeholder="Select Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                filter
            />
        );
    };

    const CompanyFilterItemTemplate = (option) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{option.name}</span>
            </div>
        );
    };

    const CompanyFilterBodyTemplate = (rowData) => {
        const company = rowData.companyName;
        return (
            <div className="flex align-items-center gap-2">
                <span>{company}</span>
            </div>
        );
    };

    const CompanyFilterClick = (e) => {
        const val = e.value || (e.target && e.target.value) || null;
        lazyState.current.CompanyFilter = val;
        setCompanyNameFilter(val);
        getCompanyWiseAttendees(false, { CompanyFilter: val });
        if (e.preventDefault) e.preventDefault();
    };

    const filterDialogFooter = (
        <div className="filter-modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '0.5rem' }}>
            <Button
                label="Reset"
                icon="pi pi-filter-slash"
                className="p-button-outlined p-button-secondary"
                onClick={() => {
                    removeFilter();
                    setFilterDialog(false);
                }}
                outlined
            />
            <Button
                label="Apply"
                icon="pi pi-check"
                className="p-button-primary"
                onClick={() => SearchFilter()}
            />
        </div>
    );

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-right">
                <Button
                    icon="pi pi-filter"
                    label="Filter"
                    className="p-button-outlined mr-2 mobile-only-btn"
                    onClick={() => setFilterDialog(true)}
                    tooltip="Filter"
                    tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                    outlined
                />
                <Button
                    disabled={!isFilterActive}
                    type="button"
                    icon="pi pi-filter-slash"
                    className="p-button-outlined mr-2"
                    onClick={() => removeFilter()}
                    tooltip="Reset Filter"
                    tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                    outlined
                />
                <Button
                    disabled={!(CompanyWiseAttendeesData != null && CompanyWiseAttendeesData.length > 0)}
                    onClick={() => {
                        getCompanyWiseAttendees(true, lazyState.current);
                    }}
                    icon="pi pi-file-excel"
                    className="mr-2"
                    tooltip="Export Excel"
                    tooltipOptions={{ position: "bottom", className: "showtooltip" }}
                    outlined
                />
            </div>
        );
    };

    //Template for pagination
    const template2 = {
        layout: ' CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        'CurrentPageReport': (options) => {
            return (
                <span className="paginator-current-report" style={{ color: 'var(--text-color)', userSelect: 'none', textAlign: 'center' }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            )
        },
        RowsPerPageDropdown: (options) => {
            return <span className="paginator-rows-per-page">Items Per Page :<Dropdown value={options.value} options={RowsPerPageDropdown} onChange={options.onChange} /></span>;
        },
    };

    return (
        <div className="trico-Grid">
            <Toast ref={toast} />
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <>
                    <div className="p-col">
                        <div className="card">
                            <h5 className="headerfont">
                                <span>
                                    <i className="fa fa-building-o mr-2"></i>Company Wise Attendees
                                </span>
                            </h5>
                            <Toolbar right={rightToolbarTemplate} className="mb-3"></Toolbar>

                            {/* Desktop Table View */}
                            <div className="attendee-status-desktop-table">
                                <DataTable
                                    size="small"
                                    stripedRows
                                    ref={dt}
                                    value={CompanyWiseAttendeesData}
                                    lazy
                                    rows={lazyState.current.rows}
                                    onSort={onSort}
                                    sortField={lazyState.current.sortField}
                                    sortOrder={lazyState.current.sortOrder}
                                    removableSort
                                    dataKey="id"
                                    className="datatable-responsive admin-datatable"
                                    responsiveLayout="scroll"
                                    filterDisplay={"row"}
                                    scrollable
                                    scrollHeight="calc(100vh - 250px)"
                                >
                                    <Column
                                        field="companyName"
                                        header="Company"
                                        sortField="companyName"
                                        sortable
                                        headerStyle={{ width: "25%", minWidth: "15rem" }}
                                        style={{ overflowWrap: "anywhere" }}
                                        filter
                                        showFilterMenu={false}
                                        filterElement={CompanyFilterTemplate}
                                        body={CompanyFilterBodyTemplate}
                                        filterField="Company"
                                        filterMenuStyle={{ width: '14rem' }}
                                    ></Column>
                                    <Column field="approvedstatus" sortable sortField='approvedstatus' header="Approved"></Column>
                                    <Column field="rejectedstatus" sortable sortField='rejectedstatus' header="Reject"></Column>
                                    <Column field="cancelledstatus" sortable sortField='cancelledstatus' header="Cancelled"></Column>
                                    <Column field="presetattendees" sortable sortField='presetattendees' header="Present"></Column>
                                </DataTable>
                            </div>

                            {/* Mobile Card View */}
                            <div className="attendee-status-mobile-cards">
                                {CompanyWiseAttendeesData && CompanyWiseAttendeesData.length > 0 ? (
                                    <div className="attendee-card-grid">
                                        {CompanyWiseAttendeesData.map((item, index) => {
                                            return (
                                                <div className="attendee-mobile-card" key={item.id || item.companyName || index}>
                                                    {/* Top header with Company Name */}
                                                    <div className="attendee-card-top flex justify-content-between align-items-center mb-2">
                                                        <div className="flex align-items-center gap-2">
                                                            <span className="attendee-company-badge font-bold text-base">
                                                                <i className="fa fa-building-o mr-2"></i>
                                                                {item.companyName || "N/A"}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Status Badges Row */}
                                                    <div className="attendee-status-badges flex flex-wrap gap-1">
                                                        <span className="status-pill status-pill-success">
                                                            <i className="fa fa-check-circle mr-1"></i>
                                                            Approved: {item.approvedstatus ?? 0}
                                                        </span>
                                                        <span className="status-pill status-pill-danger">
                                                            <i className="fa fa-times-circle mr-1"></i>
                                                            Reject: {item.rejectedstatus ?? 0}
                                                        </span>
                                                        <span className="status-pill status-pill-neutral">
                                                            <i className="fa fa-ban mr-1"></i>
                                                            Cancelled: {item.cancelledstatus ?? 0}
                                                        </span>
                                                        <span className="status-pill status-pill-yes">
                                                            <i className="fa fa-users mr-1"></i>
                                                            Present: {item.presetattendees ?? 0}
                                                        </span>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="attendee-empty-state text-center p-4 card surface-card">
                                        <i className="fa fa-inbox text-4xl text-400 mb-2"></i>
                                        <p className="text-600 m-0">No records found</p>
                                    </div>
                                )}
                            </div>

                            <Paginator
                                className='justify-content-end admin-paginator'
                                first={lazyState.current.first}
                                rows={lazyState.current.rows}
                                totalRecords={totalRecords}
                                template={template2}
                                rowsPerPageOptions={RowsPerPageDropdown}
                                onPageChange={onBasicPageChange}
                            ></Paginator>

                            {/* Mobile Filter Dialog */}
                            <Dialog
                                visible={filterDialog}
                                draggable={false}
                                header={
                                    <div className="dialog-header-content flex align-items-center gap-2">
                                        <i className="fa fa-filter text-primary dialog-header-icon mr-2"></i>
                                        <span className="dialog-header-title">Filter Reports</span>
                                    </div>
                                }
                                modal
                                className="p-fluid admin-dialog attendee-filter-dialog"
                                footer={filterDialogFooter}
                                onHide={() => setFilterDialog(false)}
                            >
                                <div className="filter-dialog-grid">
                                    <div className="filter-field-item">
                                        <label>Company</label>
                                        <MultiSelect
                                            value={companyNameFilter || lazyState.current.CompanyFilter}
                                            options={companyList}
                                            itemTemplate={CompanyFilterItemTemplate}
                                            optionLabel="name"
                                            onChange={(e) => {
                                                const val = e.value || (e.target && e.target.value) || null;
                                                lazyState.current.CompanyFilter = val;
                                                setCompanyNameFilter(val);
                                            }}
                                            placeholder="Select Company"
                                            maxSelectedLabels={1}
                                            filter
                                        />
                                    </div>
                                </div>
                            </Dialog>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default CompanyWiseAttendees;